import {IModuleDirection} from "@/model/Locker/IModule";
import {IShortLocker, IShortUser} from "@/model/shortInterfaces";

export enum ELockerStatuses {
  Deleted = 'Deleted',
  Online = 'Online',
  Off = 'Off',
  Install = 'Install',
}

export interface ILocker {
  id: number;
  community_id: number;
  name: string;
  external_name: null|string;
  abbreviation: string;
  channel_id: number;
  default_phone_prefix: string;
  description: string;
  directory_delivery: boolean;
  gate_codes: string[];
  internal_delivery_type: string;
  la_liga: boolean;
  last_ping: string;
  location_description: string;
  location_building_name: string;
  location_building_floor: string;
  locker23_feature: boolean;
  directory_deliveries_24: boolean;
  directory_deliveries_25: boolean;
  identifier: string;
  languages: string[];
// should be a date field but some code changes would be required for that
  machine_number: string;
  notification_sent_at: string;
  only_local_delivery: boolean;
  os_cpu: string;
  os_memory: string;
  os_version: string;
  should_send_reminders: boolean;
  sim: string | null;
  status: string;
  // theme_name: string;
  logo_image_id: number|null;
  logoImageLocation: string|null;
  version: string;
  created_at: string;
  updated_at: string;

  cells: ICell[];
  companies: string[];
  lockerCompanies: any[];
  service_provider_ids: string[];
  user_ids: {
    operator: number[];
    owner: number[];
  };
  screenConfig?: IScreenConfig;
}
export interface IScreenConfig {
  orientation: string;
  resolution: string;
  applied: boolean;
}

export interface ILocker2 {
  id: number;
  name: string;
  community_id?: number;
  community_name?: string;
  community_vertical?: number | null;
  community?: string;
  external_name: null|string;
  abbreviation: string;
  channel_id: number;
  owner_user_id?: number;
  zone_id?: number;
  default_phone_prefix: string;
  delivery_by_phone: boolean;
  description: string;
  directory_delivery: boolean;
  gate_codes: string[];
  internal_delivery_type: string;
  la_liga: boolean;
  last_ping: string;
  location_description: string;
  location_building_name: string;
  location_building_floor: string;
  locker23_feature: boolean;
  directory_deliveries_24: boolean;
  directory_deliveries_25: boolean;
  identifier: string;
  languages: string[];
// should be a date field but some code changes would be required for that
  machine_number: string;
  notification_sent_at: string;
  only_local_delivery: boolean;
  os_cpu: string;
  os_memory: string;
  os_version: string;
  should_send_reminders: boolean;
  sim: string | null;
  status: string;
  // theme_name: string;
  version: string;
  landing_version: number;
  screenConfig?: IScreenConfig;

  created_at: string;
  updated_at: string;

  gateCodes: string[];
  lockerCompanyIds: number[];
  lockerCompanyUserCounts: object;
  serviceProviderIds: string[];
  ownerUser: IShortUser;
  operatorUsers: IShortUser[];
  transferDestinations: IShortLocker[];
  show_register_landing_qr_code: boolean;
}

// the idea is that this in an abstract cell, eg before creating one
export interface IAbstractCell {
  name: string;
  connector: string;
  cell_size_id: number;
  accessible: boolean;
}

export interface IRestrictCellsActionParam  {
  lockerId: number,
  cellId: number,
  spId: number,
}

export interface IRestrictions {
  service_provider_id: number;
}

// and this is an existing cell (thus it has ID and stuff assigned when this cell was created)
export interface ICell extends IAbstractCell {
  id: number;
  display_number: string;
  locker_number: string;
  type: string; // not the type of the cell, just the model class from php
  block: number;
  active: boolean;
  blocked_column: boolean;
  column_order: number;
  direction: IModuleDirection;
  restrictions: IRestrictions[];
}
